import { useStore } from 'zustand'
import { appStore } from './app'
import { uiStore } from './ui'
import { userStore } from './user'
import { networkDataStore } from './networkData'
import { statsSettingsStore } from './statsSettings'

/**
 * The React face of the five session stores (Phase 1B). Each hook subscribes a
 * component to one selected slice; it re-renders only when that slice changes.
 * Vue reads the same stores through the mirror shells in core/store/, so a
 * write from either side reaches both. Actions are the module-level
 * `xxxActions` objects — import those directly; there is no hook for them.
 */
type StateOf<S> = S extends { getState: () => infer T } ? T : never

export function useAppState<T>(selector: (s: StateOf<typeof appStore>) => T): T {
  return useStore(appStore, selector)
}
export function useUiState<T>(selector: (s: StateOf<typeof uiStore>) => T): T {
  return useStore(uiStore, selector)
}
export function useUserState<T>(selector: (s: StateOf<typeof userStore>) => T): T {
  return useStore(userStore, selector)
}
export function useNetworkDataState<T>(selector: (s: StateOf<typeof networkDataStore>) => T): T {
  return useStore(networkDataStore, selector)
}
export function useStatsSettingsState<T>(selector: (s: StateOf<typeof statsSettingsStore>) => T): T {
  return useStore(statsSettingsStore, selector)
}
